import axios from 'axios';
import router from '../router/index'
//import qs from 'qs';
import NProgress from 'nprogress';
import { BASE_URL } from '../config/app';
import store from '../store/index';
import { API_CODE } from '../store/mutation-types';
import VueCookies from 'vue-cookies'

// 创建axios实例
const service = axios.create({
    baseURL: BASE_URL, // api的base_url
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    withCredentials:true,
    // headers: { 'Content-Type': 'application/json' },
});

let count = 0;

// request拦截器
service.interceptors.request.use(
    (config) => {
        NProgress.start();
        count += 1;

        const temp = config;
        if (config.data) {
            //temp.data = qs.stringify(config.data);
             temp.data = config.data;
        }
        if (store.getters.token) {
            temp.headers.token = store.getters.token;
        }
        return config;
    },
    (error) => {
        // Do something with request error
        Promise.reject(error);
    },
);

// respone拦截器
service.interceptors.response.use(
    (response) => {
        count -= 1;
        if (count === 0) {
            NProgress.done();
        }

        if (response.data.code === API_CODE.INVALID_TOKEN) {
            VueCookies.set('ADMIN-TOKEN', '');
            store.dispatch('FedLogout')
                .then(() => {
                    router.replace({
                        path: '/',
                    });
                });
        } else if (response.data.code === API_CODE.SYSTEM_CODE) {
            store.dispatch('FedLogout')
                .then(() => {
                });
            router.replace({
                path: '/system',
            });
        }
        return response.data;
    },
    (error) => {
        count -= 1;
        if (count === 0) {
            NProgress.done();
        }
        return Promise.reject(error);
    },
);

export default service;
